<template>
  <div>
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
        โปรโมชันเด่นของบริการอินเทอร์เน็ตประจำที่
        <small></small>
      </h1>
      <ol class="breadcrumb">
        <li>
          <a href="#">
            <i class="fa fa-dashboard"></i> จัดการข้อมูลอินเทอร์เน็ตประจำที่
          </a>
        </li>
      </ol>
    </section>

    <section class="content">
      <transition name="page" mode="out-in">
        <div class="row">
          <div class="col-xs-12">
            <div class="box box-primary">
              <div class="box-header">
                <!-- <h3 class="box-title">Hover Data Table</h3> -->
                <div class="layout_filter_search">
                  <h2>ตัวเลือกการค้นหา</h2>
                  <div class="row">
                    <el-form
                      size="mini"
                      :label-position="label_position"
                      label-width="150px"
                      :model="form"
                      ref="ruleForm"
                      class="demo-ruleForm"
                    >
                      <div class="col-sm-12">
                        <div class="col-sm-6">
                          <el-form-item label="ชื่อรายการส่งเสริมการขาย" prop="namePromotion">
                            <el-input clearable v-model="form.promotion_name"></el-input>
                          </el-form-item>
                          <el-form-item label="ชนิดของรายการส่งเสริมการขาย" prop="typeOfservice">
                            <el-select filterable v-model="form.promotion_type">
                              <el-option label="ทั้งหมด" value=""></el-option>
                              <el-option label="รายการส่งเสริมการขายหลัก (Main)" value="main"></el-option>
                              <el-option label="รายการส่งเสริมการขายเสริม (On-top)" value="on-top"></el-option>
                            </el-select>
                          </el-form-item>
                          <el-form-item label="ช่วงเวลาเริ่มต้นการเสนอขาย">
                            <el-select filterable v-model="form.quarter" style="width: 30%">
                              <el-option label="1" value="1"></el-option>
                              <el-option label="2" value="2"></el-option>
                              <el-option label="3" value="3"></el-option>
                              <el-option label="4" value="4"></el-option>
                            </el-select>
                            <el-date-picker
                              v-model="form.year"
                              type="year"
                              style="width: 70%"
                            ></el-date-picker>
                          </el-form-item>
                        </div>
                        <div class="col-sm-6">
                          <el-form-item label="ผู้ให้บริการ" prop="provider">
                            <el-select filterable v-model="form.provider_id">
                              <el-option value="" label="ทั้งหมด"></el-option>
                              <el-option v-for="provider in this.list_providers" :key="provider.id" :label="provider.brand_name" :value="provider.info"></el-option>
                            </el-select>
                          </el-form-item>
                          <el-form-item label="ประเภทเทคโนโลยีของการให้บริการ" prop="service_type">
                            <el-select filterable v-model="form.promotion_technology">
                              <el-option label="ทั้งหมด" value=""></el-option>
                              <el-option label="FTTx" value="FTTx"></el-option>
                              <el-option label="VDSL" value="VDSL"></el-option>
                              <el-option label="ADSL" value="ADSL"></el-option>
                              <el-option label="WiFi" value="WiFi"></el-option>
                              <el-option label="VAS" value="VAS"></el-option>
                            </el-select>
                          </el-form-item>
                        </div>
                        <div class="col-sm-12">
                          <el-form-item label="ช่วงราคา (บาท)" class="slider_price">
                            <el-slider
                              v-model="form.priceRange"
                              :step="100"
                              range
                              :max="1600"
                              :show-input="true"
                              :show-stops="true"
                              :format-tooltip="changeTooltip"
                              :marks="{0:'0',100:'100',200:'200',300:'300',400:'400',500:'500',600:'600',700:'700',800:'800',900:'900',1000:'1000',1100:'1100',1200:'1200',1300:'1300',1400:'1400',1500:'1500',1600:'1500 ขึ้นไป'}"
                            ></el-slider>
                          </el-form-item>
                        </div>
                      </div>
                      <div class="layout_filter_btn">
                        <button type="button" class="btn btn-primary" @click="loadData">ค้นหา</button>
                      </div>
                    </el-form>
                  </div>
                </div>
              </div>
              <!-- table -->
              <div class="table-responsive">
                <div class="box-body">
                  <div style="padding-bottom: 20px" align="right">
                    <el-button @click="get_download_data()" type="primary">Export Excel</el-button>
                  </div>
                  <data-tables-server
                    @query-change="loadData"
                    :data="table_data"
                    :total="total"
                    :page-size="form.pageSize"
                    :pagination-props="{ background: true, pageSizes: [10, 20, 50] }"
                  >
                  <el-table-column class-name="code" prop="promotion_code" sortable="custom" label="รหัสรายการส่งเสริมการขาย" width="225" ></el-table-column>
                  <el-table-column class-name="name" prop="promotion_name_th" sortable="custom" label="ชื่อรายการส่งเสริมการขาย (ภาษาไทย)" width="290"></el-table-column>
                  <el-table-column class-name="name" prop="promotion_name_en" sortable="custom" label="ชื่อรายการส่งเสริมการขาย (ภาษาอังกฤษ)" width="290"></el-table-column>
                  <el-table-column class-name="category" prop="promotion_technology" sortable="custom" label="ประเภทเทคโนโลยีของการให้บริการ" width="270" align="center"></el-table-column>
                  <el-table-column class-name="type" prop="promotion_type" sortable="custom" label="ชนิดของรายการส่งเสริมการขาย" width="265" align="center"></el-table-column>
                  <el-table-column label="ระยะเวลา" align="center">
                    <el-table-column class-name="date" prop="start_sale_date" sortable="custom" label="เริ่มต้นของการเสนอขาย" width="200">
                      <template slot-scope="scope" >
                        {{scope.row.start_sale_date === 'Invalid date' ? '':scope.row.start_sale_date}}
                      </template>
                    </el-table-column>
                    <el-table-column class-name="date" prop="end_sale_date" sortable="custom" label="สิ้นสุดของการเสนอขาย" width="195">
                      <template slot-scope="scope" >
                        {{scope.row.end_sale_date === 'Invalid date' ? '':scope.row.end_sale_date}}
                      </template>
                    </el-table-column>
                  </el-table-column>
                  <el-table-column class-name="price" prop="promotion_price"       sortable="custom" label="ค่าบริการเหมาจ่ายรวมตามสิทธิการใช้งาน (บาท)" width="320" align="center"></el-table-column>
                  <el-table-column label="สิทธิการใช้งานที่ผู้ใช้บริการได้รับจำแนกตามประเภทบริการ" align="center">
                    <el-table-column class-name="service" prop="download_speed"        sortable="custom" label="ความเร็วดาวน์โหลด Mbps" width="220" align="center"></el-table-column>
                    <el-table-column class-name="service" prop="upload_speed"          sortable="custom" label="ความเร็วอัปโหลด Mbps" width="200" align="center"></el-table-column>
                  </el-table-column>
                  <el-table-column label="อัตราค่าบริการต่อหน่วย" align="center">
                    <el-table-column class-name="average" prop="internet_per_Mbps"       sortable="custom" label="บริการ Internet (บาท/Mbps)" width="235" align="right"></el-table-column>
                  </el-table-column>
                  <el-table-column class-name="promotion_url" prop="promotion_link_url"      sortable="custom" label="ลิงก์เว็บไซต์หรือลิงก์รายการส่งเสริมการขายของผู้ให้บริการ" width="250">
                    <template slot-scope="scope">
                      {{ scope.row.promotion_link_url ? decodeURI(scope.row.promotion_link_url) : '' }}
                    </template>
                  </el-table-column>
                    <el-table-column label="จัดการ" align="center" width="80" fixed="right">
                      <template slot-scope="scope">
                        <el-tooltip class="item" effect="light" content="ดูข้อมูล" placement="top" :enterable="false">
                          <el-button
                            class="custom-btn"
                            size="mini"
                            type="success"
                            @click="handleView(scope.$index, scope.row)"
                          >
                            <i class="el-icon-view"></i>
                          </el-button>
                        </el-tooltip>
                      </template>
                    </el-table-column>
                  </data-tables-server>
                  <!-- dialog -->
                  <el-dialog
                    v-if="dialogFormVisible"
                    title="รายละเอียดรายการส่งเสริมการขาย"
                    :visible.sync="dialogFormVisible"
                    >
                    <table>
                      <tr>
                        <td colspan="2"><b>รายละเอียดเบื้องต้น</b></td>
                      </tr>
                      <tr>
                        <td v-bind:style="styleOption">
                          ชื่อรายการส่งเสริมการขาย : 
                        </td>
                        <td v-bind:style="styleOption">
                          {{ this.data_dialog.promotion_name_th }}
                        </td>
                      </tr>
                      <tr>
                        <td v-bind:style="styleOption">
                          ประเภทเทคโนโลยีของการให้บริการ : 
                        </td>
                        <td v-bind:style="styleOption">
                          {{ this.data_dialog.promotion_technology }}
                        </td>
                      </tr>
                      <tr>
                        <td v-bind:style="styleOption">
                          ชนิดของรายการส่งเสริมการขาย : 
                        </td>
                        <td v-bind:style="styleOption">
                          {{ this.data_dialog.promotion_type == 'main' ? 'รายการส่งเสริมการขายหลัก' : 'รายการส่งเสริมการขายเสริม'}}
                        </td>
                      </tr>
                      <tr>
                        <td v-bind:style="styleOption">
                          ระยะเวลา : 
                        </td>
                        <td v-bind:style="styleOption">
                          {{moment(this.data_dialog.start_service_date).format('DD-MM-YYYY')}} ถึง{{this.data_dialog.end_service_date != '' ? ' ' + this.data_dialog.end_service_date : 'ปัจจุบัน'}}
                        </td>
                      </tr>
                      <tr>
                        <td v-bind:style="styleOption">
                          ค่าบริการเหมาจ่ายรวมตามสิทธิการใช้งาน : 
                        </td>
                        <td v-bind:style="styleOption">
                          {{ this.data_dialog.promotion_price }} บาท
                        </td>
                      </tr>
                      <tr>
                        <td colspan="2">
                          <b>สิทธิการใช้งานที่ผู้ใช้บริการได้รับจำแนกตามประเภทบริการ</b>
                          </td>
                      </tr>
                      <tr>
                        <td v-bind:style="styleOption">
                          ความเร็วดาวน์โหลด :
                        </td>
                        <td v-bind:style="styleOption">
                          {{ this.data_dialog.download_speed }} Mbps
                        </td>
                      </tr>
                      <tr>
                        <td v-bind:style="styleOption">
                          ความเร็วอัปโหลด :
                        </td>
                        <td v-bind:style="styleOption">
                          {{ this.data_dialog.upload_speed }} Mbps
                        </td>
                      </tr>
                      <tr>
                        <td v-bind:style="styleOption">
                           อัตราค่าบริการต่อหน่วย :
                        </td>
                        <td v-bind:style="styleOption">
                          {{ this.data_dialog.internet_per_Mbps ? Math.round(this.data_dialog.internet_per_Mbps * 100)/100 + ' บาท/Mbps' : '-' }}
                        </td>
                      </tr>
                      <tr>
                        <td v-bind:style="styleOption">
                          เงื่อนไขอื่นๆ / ข้อกำหนด ของการใช้บริการ : 
                        </td>
                        <td v-bind:style="styleOption">
                          {{ this.data_dialog.promotion_condition_th }}
                        </td>
                      </tr>
                      <tr>
                        <td colspan="2"><b>สิทธิพิเศษ</b></td>
                      </tr>
                      <tr>
                        <td v-bind:style="styleOption">
                          บริการความบันเทิง : 
                        </td>
                        <td v-bind:style="styleOption">
                          {{ this.data_dialog.privilege_content_th ? this.data_dialog.privilege_content_th : '-' }}
                        </td>
                      </tr>
                      <tr>
                        <td v-bind:style="styleOption">
                          บริการโทรศัพท์เคลื่อนที่ : 
                        </td>
                        <td v-bind:style="styleOption">
                          {{ this.data_dialog.privilege_mobile_th ? this.data_dialog.privilege_mobile_th : '-' }}
                        </td>
                      </tr>
                      <tr>
                        <td v-bind:style="styleOption">
                          บริการ WiFi/Hotspot : 
                        </td>
                        <td v-bind:style="styleOption">
                          {{ this.data_dialog.privilege_wifi_th ? this.data_dialog.privilege_wifi_th : '-' }}
                        </td>
                      </tr>
                      <tr>
                        <td v-bind:style="styleOption">
                          บริการพรีเมียม : 
                        </td>
                        <td v-bind:style="styleOption">
                          {{ this.data_dialog.privilege_premium_th ? this.data_dialog.privilege_premium_th : '-' }}
                        </td>
                      </tr>
                      <tr>
                        <td v-bind:style="styleOption">
                          อุปกรณ์อื่นๆ : 
                        </td>
                        <td v-bind:style="styleOption">
                          {{ this.data_dialog.privilege_device_th ? this.data_dialog.privilege_device_th : '-' }}
                        </td>
                      </tr>
                      <tr>
                        <td v-bind:style="styleOption">
                          การให้บริการอื่นๆ : 
                        </td>
                        <td v-bind:style="styleOption">
                          {{ this.data_dialog.privilege_other_th ? this.data_dialog.privilege_other_th : '-' }}
                        </td>
                      </tr>
                      <tr></tr>
                      <tr>
                        <td v-bind:style="styleOption">
                          ลิงก์เว็บไซต์ หรือ ลิงก์รายการส่งเสริมการขาย : 
                        </td>
                        <td v-bind:style="styleOption">
                          {{ this.data_dialog.promotion_link_url ? decodeURI(this.data_dialog.promotion_link_url) : '-' }}
                        </td>
                      </tr>
                    </table>
                  </el-dialog>
                </div>
              </div>
              <!-- ///table -->
            </div>
          </div>
        </div>
      </transition>
    </section>
    <!-- /.content -->
  </div>
</template>
<style>
.code {
  background-color: #b3d9ff;
}
.name ,.separate_price {
  background-color: #ffffcc;
}
.category ,.privilege {
  background-color: #ffe6e6;
}
.type ,.service {
  background-color: #f2f2f2
}
.service_days {
  background-color: #ccffee
}
.date ,.average {
  background-color: #cce6ff
}
.price {
  background-color: #d9f2e6
}
.charge_type {
  background-color: #ffd9b3
}
.condition {
  background-color: #ffcccc
}
.promotion_url {
 background-color: #eeccff
}
</style>
<script>
import { mapState,mapActions,mapGetters,mapMutations } from "vuex"
import Cookie from "cookies-js";
import modal_user from "../Modal/Modal_user_details";
import modal_detail from "../Modal/Modal_internet_popular";
import moment from 'moment'
var json2csv = require('json2csv')
const { Parser } = require('json2csv');
let CsvExport = function(data, fields, fileName) {
  try {
    const parser = new Parser({fields});
    // console.log(json2csv.parse(data, {fields}))
    const result = parser.parse(data);
    var csvContent = 'data:text/csvcharset=GBK,\uFEFF' + result
    var encodedUri = encodeURI(csvContent)
    var link = document.createElement('a')
    link.setAttribute('href', encodedUri)
    link.setAttribute('download', `${(fileName || 'Popular_pro_internet')}.csv`)
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  } catch (err) {
    console.error(err)
  }
}
export default {
  created() {
    this.$store.dispatch('ListOperator/fetch_table')
  },
  data() {
    return {
      loading: false,
      checkPermission: false,
      label_position: "top",
      dialogVisible: false,
      dialogFormVisible: false,
      styleOption: {
        textAlign: 'left',
        width: '50%',
        verticalAlign: 'top'
      },
      styleCaption: {
        textAlign: 'center',
        fontSize: '16px',
        fontWeight: 'bold'
      },
      list_providers: [],
      form: {
        page : 1,
        pageSize: 10,
        promotion_name: "",
        provider_id: "",
        promotion_type: "",
        promotion_technology: "",
        dateRange: [new Date(), new Date()],
        quarter: moment(new Date()).quarter(),
        year: moment(new Date()).add('y').format('YYYY'),
        priceRange: [0, 1600]
      }
    };
  },
  mounted(){
    setTimeout(() => { this.form.provider_id = this.store_provider_id ? this.store_provider_id : "" }, 500);
  },
  computed: {
    ...mapState({
      table_data : store => store.Report_popular_internet.lists,
      total : store => store.Report_popular_internet.total,
      details : store => store.Report_popular_internet.details,
      store_provider_id : store => store.Report_popular_internet.provider_id,
      download_form : store => store.Report_popular_internet.download_form,
      download_data : store => store.Report_popular_internet.download_data,
      fields : store => store.Report_popular_internet.fields
    }),
    ...mapGetters({
      providers : "ListOperator/list_broadband"
    })
  },
  watch:{
    download_data: {
      handler : function(reload, empty) {
        // this.exportAll(reload)
      }
    },
    providers: {
      handler : function(reload, empty) {
        this.list_providers = reload.sort(function(a, b){
            var nameA=a.brand_name.toLowerCase(), nameB=b.brand_name.toLowerCase()
            if (nameA < nameB) //sort string ascending
                return -1 
            if (nameA > nameB)
                return 1
            return 0 
        })
      }
    }
  },
  methods: {
    ...mapActions({
      searching : "Report_popular_internet/searchPopularPromotion",
      download : "Report_popular_internet/downloadPopularPromotion"
    }),
    get_download_data() {
      this.download(this.download_form)
    },
    exportAll(data) {
      let fields = this.fields
      CsvExport(data, fields, 'Popular_pro_internet')
    },
    loadData(queryInfo){
      if(queryInfo.type == 'sort'){
        this.form.sort = {
          prop: queryInfo.sort.prop,
          order: queryInfo.sort.order
        }
      } 
      this.loading = true
      this.form.page = queryInfo.page || 1;
      this.form.pageSize = queryInfo.pageSize || 10;
      this.searching(this.form)
      setTimeout(() => {
        this.data = this.table_data
        this.loading = false
      }, 500);
    },
    handleClose(done) {
      done();
    },
    changeTooltip(value) {
      if (value == 1600) {
        return "1500 ขึ้นไป";
      }
      return value;
    },
    handleView(index, row) {
      this.data_dialog = row
      this.dialogFormVisible = true
    }
  }
};
</script>
